import { Facebook, Instagram, Search, Music2, MapPin, MessageCircle, Globe, Smartphone, Utensils, Phone, Footprints, Mail, Handshake } from "lucide-react";

export const CHANNELS = {
  facebook:   { label: "Facebook",      cls: "bg-[#e8f0fe] text-[#1b4fbf] border-[#1b4fbf]/30",       Icon: Facebook },
  instagram:  { label: "Instagram",     cls: "bg-[#fdeaf3] text-[#b5236e] border-[#b5236e]/30",       Icon: Instagram },
  google:     { label: "Google",        cls: "bg-[#fff4e5] text-[#b45309] border-[#b45309]/30",       Icon: Search },
  tiktok:     { label: "TikTok",        cls: "bg-neutral-900 text-white border-neutral-900",          Icon: Music2 },
  tripadvisor:{ label: "TripAdvisor",   cls: "bg-[#e6f7ef] text-[#0f7a4f] border-[#0f7a4f]/30",       Icon: MapPin },
  whatsapp:   { label: "WhatsApp",      cls: "bg-[#e7f9ee] text-[#128c4a] border-[#128c4a]/30",       Icon: MessageCircle },
  sito:       { label: "Sito web",      cls: "bg-[#f1e6da] text-[#4a1c17] border-[#4a1c17]/30",       Icon: Globe },
  app:        { label: "App / Menu QR", cls: "bg-[#fdf6e9] text-[#8a5a12] border-[#C48B31]/60",       Icon: Smartphone },
  thefork:    { label: "TheFork",       cls: "bg-[#e6f4ef] text-[#1b6b4a] border-[#1b6b4a]/30",       Icon: Utensils },
  telefono:   { label: "Telefono",      cls: "bg-slate-100 text-slate-700 border-slate-300",          Icon: Phone },
  walkin:     { label: "Di persona",    cls: "bg-stone-100 text-stone-700 border-stone-300",          Icon: Footprints },
  email:      { label: "Email",         cls: "bg-indigo-50 text-indigo-700 border-indigo-200",        Icon: Mail },
  online:     { label: "Online",        cls: "bg-white text-neutral-600 border-neutral-200",          Icon: Globe },
  partner:    { label: "Partner",       cls: "bg-[#fdf6e9] text-[#4a1c17] border-[#C48B31]",          Icon: Handshake },
};

export const MANUAL_CHANNELS = ["telefono", "whatsapp", "walkin", "email", "instagram", "facebook"];

const LEGACY = { thefork: "thefork", admin: "telefono", online: "online" };

export const channelOf = (b) => {
  const key = b.channel || LEGACY[b.origin] || "online";
  const def = CHANNELS[key] || CHANNELS.online;
  return { key, ...def, label: b.channel_label || def.label };
};

export function ChannelBadge({ b, size = "sm", testId }) {
  const c = channelOf(b);
  const Icon = c.Icon;
  const sz = size === "md" ? "px-2.5 py-1 text-[11px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span title={`Canale: ${c.label}`} data-testid={testId || `channel-${b.id}`} data-channel={c.key}
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${sz} ${c.cls}`}>
      <Icon className="h-3 w-3" /> {c.label}
    </span>
  );
}
